import { Group, Stack, Text, Title } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';

import { useTranslation } from '@apple/lib/i18next';
import { TitleLayout } from '@apple/ui/layouts/TitleLayout';
import { SupportForm } from '@apple/ui/shell/components/support-form';
import { HelpPage } from '@apple/ui/shell/pages/HelpPage';

import { requireAuth } from '@apple/features/auth/utils/require-auth';

export const Route = createFileRoute('/_authed/help')({
	beforeLoad: args => requireAuth(args),
	component: HelpRoute,
});

function HelpRoute() {
	const { t } = useTranslation('help');

	const supportForm = useMemo(
		() => (
			<Stack>
				<Stack mt='xl'>
					<Title order={3}>{t('assistanceTitle')}</Title>
				</Stack>
				<Group grow gap='xl' align='flex-start'>
					<Stack mt={'xs'}>
						<Text flex={1}>{t('channel.notes.includeAllInformation')}</Text>
						<Text flex={1}>{t('channel.notes.allowResponse')}</Text>
					</Stack>
					<SupportForm />
				</Group>
			</Stack>
		),
		[t],
	);

	return (
		<TitleLayout title={t('title')}>
			<HelpPage description={t('channel.notes.faqDescription')} children={supportForm} />
		</TitleLayout>
	);
}
